import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/company.svg";
var CompanyOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  CompanyOutline_default as default
};
